import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_19 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_20 = { class: "indicator-label" }
const _hoisted_21 = { class: "indicator-progress" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_24 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ire_create_sizes",
  "aria-expanded": "true",
  "aria-controls": "kt_ire_create_sizes"
}
const _hoisted_25 = { class: "card-title m-0" }
const _hoisted_26 = { class: "fw-bolder m-0" }
const _hoisted_27 = {
  id: "kt_ire_create_sizes",
  class: "collapse show"
}
const _hoisted_28 = { class: "card-body border-top p-9" }
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col fv-row" }
const _hoisted_31 = { class: "py-0" }
const _hoisted_32 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_33 = ["href", "aria-controls"]
const _hoisted_34 = { class: "me-3 rotate-90" }
const _hoisted_35 = { class: "svg-icon svg-icon-3" }
const _hoisted_36 = { class: "me-3" }
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = { class: "text-gray-800 fw-bolder" }
const _hoisted_39 = ["id"]
const _hoisted_40 = { class: "d-flex flex-wrap py-5" }
const _hoisted_41 = { class: "flex-equal me-5" }
const _hoisted_42 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_43 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_47 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_48 = { class: "flex-equal" }
const _hoisted_49 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_52 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_53 = { class: "flex-equal" }
const _hoisted_54 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "   ", -1)
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "svg-icon svg-icon-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_60 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_61 = { class: "indicator-label" }
const _hoisted_62 = { class: "indicator-progress" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_64 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_65 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ire_property_age",
  "aria-expanded": "true",
  "aria-controls": "kt_ire_property_age"
}
const _hoisted_66 = { class: "card-title m-0" }
const _hoisted_67 = { class: "fw-bolder m-0" }
const _hoisted_68 = {
  id: "kt_ire_property_age",
  class: "collapse show"
}
const _hoisted_69 = { class: "card-body border-top p-9" }
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = { class: "col fv-row" }
const _hoisted_72 = { class: "py-0" }
const _hoisted_73 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_74 = ["href", "aria-controls"]
const _hoisted_75 = { class: "me-3 rotate-90" }
const _hoisted_76 = { class: "svg-icon svg-icon-3" }
const _hoisted_77 = { class: "me-3" }
const _hoisted_78 = { class: "d-flex align-items-center" }
const _hoisted_79 = { class: "text-gray-800 fw-bolder" }
const _hoisted_80 = ["id"]
const _hoisted_81 = { class: "d-flex flex-wrap py-5" }
const _hoisted_82 = { class: "flex-equal me-5" }
const _hoisted_83 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_84 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_85 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_87 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_88 = { class: "indicator-label" }
const _hoisted_89 = { class: "indicator-progress" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('read', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateIreAreaValue')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitUpdate,
              "validation-schema": _ctx.areaSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.area.areaId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.area.areaId) = $event)),
                        disabled: "true",
                        requierd: true,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('sort')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "number",
                        modelValue: _ctx.area.sort,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.area.sort) = $event)),
                        name: "sort",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('sort')
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "sort" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('customUpdatedAt')) + ": ", 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "customUpdatedAt",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        modelValue: _ctx.area.customUpdatedAt,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.area.customUpdatedAt) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  (_ctx.can('update', 'instant-rent-estimator'))
                    ? (_openBlock(), _createElementBlock("button", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_21, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_22
                        ])
                      ], 512))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('read', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.translate('IreAvailableSizes')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.area['ire_size_config_v2'], (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_ire_size_${index}`,
                            "aria-controls": `kt_ire_size_${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "true"
                          }, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              name: "isEnabled",
                              type: "checkbox",
                              checked: item.isEnabled == false ? true : false,
                              modelValue: item.isEnabled,
                              "onUpdate:modelValue": ($event: any) => ((item.isEnabled) = $event)
                            }, null, 8, ["checked", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("span", _hoisted_35, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, _toDisplayString(item.ire_size_v2.titleAr), 1)
                              ])
                            ])
                          ], 8, _hoisted_33)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_ire_size_${index}`,
                          class: _normalizeClass(
                    item.id ? 'fs-6 ps-10 collapse show' : 'fs-6 ps-10 collapse'
                  ),
                          "data-bs-parent": "#kt_property_type",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("table", _hoisted_42, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.translate('isBaseSize')), 1),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_Field, {
                                        class: "form-check-input",
                                        name: "isBaseSize",
                                        type: "checkbox",
                                        value: true,
                                        modelValue: item.isBase,
                                        "onUpdate:modelValue": ($event: any) => ((item.isBase) = $event),
                                        checked: item.isBase
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "checked"])
                                    ])
                                  ]),
                                  _hoisted_44
                                ]),
                                _createElementVNode("tbody", null, [
                                  (!item.isBase)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                                        _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.translate('percentage')), 1),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            autocomplete: "off",
                                            class: "form-control form-control-sm form-control-solid",
                                            placeholder: _ctx.translate('percentage'),
                                            "onUpdate:modelValue": ($event: any) => ((item.percentage) = $event)
                                          }, null, 8, _hoisted_47), [
                                            [_vModelText, item.percentage]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("table", _hoisted_49, [
                                _createElementVNode("tbody", null, [
                                  (item.isBase)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                                        _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.translate('value')), 1),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            autocomplete: "off",
                                            class: "form-control form-control-sm form-control-solid",
                                            placeholder: _ctx.translate('value'),
                                            "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                          }, null, 8, _hoisted_52), [
                                            [_vModelText, item.value]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("table", _hoisted_54, [
                                _createElementVNode("tbody", null, [
                                  (item.id)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                                        _hoisted_56,
                                        _createElementVNode("td", null, [
                                          (_ctx.can('remove', 'instant-rent-estimator'))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: "#",
                                                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                                                onClick: _withModifiers(($event: any) => (_ctx.removeSizeConfig(item.id)), ["prevent"])
                                              }, [
                                                _createElementVNode("span", _hoisted_58, [
                                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                                                ])
                                              ], 8, _hoisted_57))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ], 10, _hoisted_39)
                      ]),
                      _hoisted_59
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_appraiser_create_prices_submit",
                ref: "submitSizeButton",
                class: "btn btn-primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmitSizeOptions && _ctx.onSubmitSizeOptions(...args)))
              }, [
                _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_62, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_63
                ])
              ], 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("h3", _hoisted_67, _toDisplayString(_ctx.translate('IrePropertyAge')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.area['ire_property_age_config_v2'], (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_property_type_${index}`,
                            "aria-controls": `kt_property_type_${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "true"
                          }, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("span", _hoisted_76, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, _toDisplayString(item.ire_property_age_v2.titleAr), 1)
                              ])
                            ])
                          ], 8, _hoisted_74)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_property_type_${index}`,
                          class: "fs-6 ps-10 collapse show",
                          "data-bs-parent": "#kt_property_type",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("table", _hoisted_83, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_84, _toDisplayString(_ctx.translate('percentage')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('percentage'),
                                        "onUpdate:modelValue": ($event: any) => ((item.percentage) = $event)
                                      }, null, 8, _hoisted_85), [
                                        [_vModelText, item.percentage]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_80)
                      ]),
                      _hoisted_86
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_appraiser_create_prices_submit",
                ref: "submitPropertyAgeButton",
                class: "btn btn-primary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSubmitAgeOptions && _ctx.onSubmitAgeOptions(...args)))
              }, [
                _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_89, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_90
                ])
              ], 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}